/**
 * Map of string names for each Lookbuilder view. Used for navigation.
 * @type {Object}
 */
export const LookbuilderViews = {
  planner: 'planner',
  category: 'category',
  detail: 'detail',
}

/**
 * Maps out the associated tags (read: subcategories) that each Lookbuilder
 * category contains. Used for data fetching and subsequent sorting of products.
 * @type {Object}
 */
export const tagsByCategory = {
  'suits-tuxedos': ['suit', 'tuxedo'],
  shirts: ['dress shirt', 'tuxedo shirt', 'sweater'],
  neckwear: ['bow tie', 'necktie'],
  shoes: ['dress shoes', 'tuxedo shoes', 'loafers'],
  'belts-suspenders': ['belt', 'suspenders'],
  'pocket-squares': ['pocket square'],
  'vests-cummerbunds': ['suit vest', 'tuxedo vest', 'cummerbund'],
  cufflinks: ['cufflinks'],
  studs: ['shirt studs'],
  'tie-clips': ['tie clip'],
}

/**
 * Maps a Lookbuilder category slug to its display name
 * @type {Object}
 */
export const categoryDisplayNames = {
  'suits-tuxedos': 'Suits & Tuxedos',
  shirts: 'Shirts',
  neckwear: 'Neckwear',
  shoes: 'Shoes',
  'belts-suspenders': 'Belts & Suspenders',
  'pocket-squares': 'Pocket Squares',
  'vests-cummerbunds': 'Vests & Cummberbunds',
  cufflinks: 'Cufflinks',
  studs: 'Studs',
  'tie-clips': 'Tie Clips',
}

/**
 * Map of product incompatibility messages which are shown in the product incompatibility modal
 * surfaced to the user.
 *
 * @type {Object}
 */
export const ProductIncompatibilityMessage = {
  TUXEDO_BELT:
    'Our tuxedo pants don’t have belt loops! If you want some help holding them up, try a pair of suspenders instead.',
  SHIRT_STUD:
    "Some of our shirts have regular front buttons instead of special buttonholes for shirt studs. If you'd like to wear studs, try a different shirt.",
  SHIRT_CUFFLINKS:
    "This shirt doesn't have convertible cuffs to put cufflinks in! If you'd like links in your look, try another shirt.",
}

/**
 * Map of product compatibility analytics messages, which are used in the "Viewed Modal" event
 *
 * @type {Object}
 */
export const ProductIncompatibilityAnalyticsMessage = {
  TUXEDO_BELT: 'Rules - Pants No Belt',
  SHIRT_STUD: 'Rules - Shirt No Studs',
  SHIRT_CUFFLINKS: 'Rules - Shirt No Cufflinks',
}

/**
 * Map of product compatibility string enums which are returned for each product from the API.
 *
 * @type {Object}
 */
export const ProductCompatibilityTags = {
  BELT_COMPATIBLE: 'belt compatible',
  CUFFLINK_COMPATIBLE: 'cufflink compatible',
  SHIRT_STUD_COMPATIBLE: 'shirt stud compatible',
}

/**
 * Map of string enums which denote the origin of removing an item
 *
 * @type {Object}
 */
export const removalOrigins = {
  CATEGORY: 'category',
  RENT_BUY: 'rent/buy',
}
